export function getCookie(name) {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return null;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

//获取当前的日期时间 格式“yyyy-MM-dd HH:MM:SS”
export function getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var minutes = date.getMinutes();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if(minutes >= 0 && minutes <=9){
        minutes = `0${minutes}`
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
            + " " + date.getHours() + seperator2 + minutes
            + seperator2 + date.getSeconds();
    return currentdate;
}
export const debounce = (fn, wait) => {
    let delay = wait|| 500
    let timer
    return function () {
        let args = arguments;
        if (timer) {
            clearTimeout(timer)
        }
        let callNow = !timer
        timer = setTimeout(() => {
            timer = null
        }, delay)
        if (callNow) fn.apply(this, args)
    }
}
export function getToken(){
    let Token = JSON.parse(sessionStorage.getItem('Token'));
    console.log(Token)
    if(Token == undefined){
        this.$router.push({path:'/login'})
    }
}
/**
 * 过滤参数
 * { obj } 要传的对象数值
 * { act } 参数act
 */
export function filterParams(obj,act) {
    let params = {};
     params['act'] = act;
    Object.keys(obj).forEach(item=>{
     if (!obj[item] || 
        obj[item] == 'undefined' || 
        obj[item] == 'null' || 
        obj[item] == 'NaN'
     ) {
      return;
     };
     params[item] = obj[item]
    
    })
    return params; 
}




